// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GaSWBKCNNNwlpn {
  display: inline-flex;
  font-weight: normal;
  cursor: pointer;
}
.GaSWBKCNNNwlpn > span {
  border-radius: var(--ds-border-radius-300, 12px);
}
.GaSWBKCNNNwlpn > span > span {
  padding: 2px 0;
  font-size: 14px;
}
.GaSWBKCNNNwlpn.XBNc6MPw3m_BP2 > span {
  background-color: var(--ds-background-accent-orange-subtler, #ffe2bd);
}
.GaSWBKCNNNwlpn.XBNc6MPw3m_BP2 > span > span {
  color: var(--ds-text-accent-yellow, #7f5f01);
}
.GaSWBKCNNNwlpn.xbL8_cOPFOW1xT > span {
  background-color: var(--ds-background-accent-red-subtler, #ffd2cc);
}
.GaSWBKCNNNwlpn.xbL8_cOPFOW1xT > span > span {
  color: var(--ds-text-accent-red, #ae2a19);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collaboratorsBadge": `GaSWBKCNNNwlpn`,
	"atLimit": `XBNc6MPw3m_BP2`,
	"overLimit": `xbL8_cOPFOW1xT`
};
export default ___CSS_LOADER_EXPORT___;
